module.exports = __webpack_public_path__ + "images/47846f26c41ca2ae8718280cfd9afa20.svg";